/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;" width="1400" >
    <v-card-title style="background-color:#006699;color:white;">
      <v-row>
        <v-col md="12">
         <span>Relatório de Stocks</span>
        </v-col>
        <div style="border:1px solid #ccc;width:300px;margin-top:-12px;">
          <v-col md="12" style="margin-top:-20px;">
            <span style="font-size:12px;">Intervalo de Datas : De   </span> <span style="color:black;font-size:12px;">{{($store.state.camposListagemProduto.dataInicio === '//') ? '==' : $store.state.camposListagemProduto.dataInicio}}</span><span style="color:white;font-size:15px;"> até</span><span style="color:black;font-size:12px;"> {{($store.state.camposListagemProduto.dataFim === '//') ? '==' : $store.state.camposListagemProduto.dataFim}}</span>
          </v-col>
          <v-col md="12" style="margin-top:-25px;">
            <span style="font-size:12px;">Filtragem por :  </span><span style="color:black;font-size:12px;">{{$store.state.camposListagemProduto.filtragem}}</span>
          </v-col>
        </div>
      </v-row>
      <v-spacer></v-spacer>
       <v-btn fab color="primary" @click="$router.push('relatorios-stock')"><v-icon>arrow_back</v-icon></v-btn>
    </v-card-title>
 <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
       <v-card-title>
        <span>Valorização de Stock</span>
         <v-spacer></v-spacer>
      </v-card-title>
        <template>
          <v-data-table :search="search" :headers="headers" :items="produtos">
          <template v-slot:item.precoSemIva="{ item }">
              <span >{{ObterValorFormatado(item.precoSemIva)+ ' Akz'}}</span>
          </template>
          <template v-slot:item.iva="{ item }">
              <span >{{ item.iva + ' %'}}</span>
          </template>
           <template v-slot:item.precoComIva="{ item }">
              <span >{{ObterValorFormatado(item.precoComIva)+ ' Akz'}}</span>
          </template>
           <template v-slot:item.unidade="{ item }">
              <span v-if="item.unidade === 1" >unidade</span>
              <span v-if="item.unidade === 2">Kg</span>
          </template>
           <template v-slot:item.precoMedio="{ item }">
             <span >{{ObterValorFormatado(item.precoMedio)+ ' Akz'}}</span>
          </template>
          <template v-slot:item.total="{ item }">
             <span >{{ObterValorFormatado(item.precoMedio*item.stock_existente)+ ' Akz'}}</span>
          </template>
                     </v-data-table>
        </template>
        <hr>
            <template  >
              <v-row>
                 <v-col md="5">
                    <span style="margin-left:54px;font-size:18px;font-weight:bold;">Nº de Produtos: <v-chip>{{produtos.length}}</v-chip></span>
                 </v-col>
                 <v-col md="3">
                   <span>Existências: <v-chip color="#006699" style="color:white;">{{totalExistencias}} </v-chip></span>
                 </v-col>
                 <v-col md="4">
                    <span style="margin-left:120px;">Total Geral: <v-chip color="#006699" style="color:white;">{{ObterValorFormatado(totalGeral)}} </v-chip></span>
                 </v-col>
              </v-row>

            </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>
import axios from '../../../plugins/axios'
import utilitarios from '../../../plugins/utilitarios'
export default {
  data: () => ({
    produtos: [],
    progresso: false,
    offsetX: false,
    offsetY: true,
    overlay: false,
    tab: null,
    utilitarios: utilitarios,
    dialog_detalhes: false,
    dados_contaCorrente: [],
    dados_contaCorrente_saidas: [],
    search: '',
    headers: [
      { text: 'Código', value: 'fkProduto' },
      {
        text: 'Nome do Produto',
        align: 'start',
        sortable: false,
        value: 'nomeProduto'
      },
      { text: 'Stock Existente', value: 'stock_existente' },
      { text: 'Preço de Custo Médio', value: 'precoMedio' },
      { text: 'Preço de Custo Médio', value: 'data_entradaStock' },
      { text: 'Total', value: 'total' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Preços' },
      { id: 3, tab: 'Estoque' },
      { id: 3, tab: 'Conta Corrente do Produto' }
    ],
    editedItem:
     {
       armazem: '',
       codigoBarra: '',
       descricaoPreco: '',
       descricaoReduzida: '',
       entrada_stk: 0,
       especificacaoProduto: '',
       familia: '',
       isencao: '',
       iva: 0,
       margem: 0,
       mercadoria: '',
       pkArmazem: 0,
       pkFamilia: 0,
       pkProduto: 0,
       precoComIva: 0,
       precoSemIva: 0,
       produto: '',
       stock_max: null,
       stock_min: null,
       tipoProduto: 0,
       unidade: 0,
       controleStock: 0,
       precoVendaDefinido: 0,
       calculoPrecoVenda: 0
     }
  }),
  computed: {
    totalExistencias () {
      let total = 0
      this.produtos.forEach(element => {
        total += parseInt(element.stock_existente)
      })
      return total
    },
    totalGeral () {
      let total = 0
      this.produtos.forEach(element => {
        total += element.stock_existente * element.precoMedio
      })
      return total
    }
  },

  created () {
    this.InitializeProdutos()
  },

  methods: {
    async  InitializeProdutos () {
      try {
        //   let  payload =""
        this.progresso = true
        this.produtos = await axios
          .post('/RelatorioValorizacaoStock', this.$store.state.camposListagemProduto)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  CarregaDadosConta (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente = await axios
          .get('/ContaCorrente-entradas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  CarregaDadosConta_saidas (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente_saidas = await axios
          .get('/ContaCorrente-saidas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    movimentacoes (item) {
      this.$store.state.produtoDetalhe = item
      this.$router.push('detalhes-movimentacao')
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },

    EditarProduto (item) {
      this.$store.state.produto = item
      this.$router.push('/Editar-Produto')
    },
    detalhes (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.CarregaDadosConta(this.editedItem.pkProduto).then(() => {
        this.CarregaDadosConta_saidas(this.editedItem.pkProduto).then(() => {
          this.dialog_detalhes = true
        })
      })
    }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
</style>
